// v3/design-system/primitives/label.tsx — Label primitive
// Uses @radix-ui/react-label for proper htmlFor/id pairing.
// Zero imports from v1/v2.

import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '../utils';

// The quiet form-label voice is the DEFAULT (type carries hierarchy, chrome
// disappears): 12px semibold muted — the same voice StepForm and the
// workflow forms were overriding to on every use. Deviations opt out via
// className; they should be rare and deliberate.
const labelVariants = cva(
  'text-xs font-semibold leading-none text-muted-foreground peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
);

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof labelVariants>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(labelVariants(), className)}
    {...props}
  />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
